<div [ngClass]="{'anpp': isAnpp}">
  <div class="modal-header">
    <h4 class="modal-title" translate>
      page.entreprises.modals.title
    </h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="formGroup" #form="ngForm" (submit)="onSubmit()" novalidate>


      <div class="modal-body"  >

     <div class="mb-3">
      <app-multiselect id="multis"
      controlName="multis"
      [items]="headers"
      bindLabel="libelle"
      maxWidth="initial"
      [ngClass]="{ 'is-invalid': multis.errors?.required }">
    </app-multiselect>
    <ng-container *ngIf="form.submitted">
      <div *ngIf="multis.errors?.required" class="form-error" translate>label.obligatoire</div>
    </ng-container>
  </div>
   </div>
      <div class="actions-bar">
        <button type="button" (click)="onClose()" class="btn btn-light me-2" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary"
          translate>Valider</button>
      </div>
    </form>
  </div>
</div>

